<template>
  <header-app titlepage="شرکت بازرگانی یزدتکس" back=""></header-app>

  <v-main class="main" >
    <pic-link></pic-link>
    <category></category>
    <div class="clearfix"></div>
  </v-main>
  <footer-app selectedItem="2"></footer-app>
</template>

<script>
import { defineComponent } from 'vue';

// Components
import HelloWorld from '../components/HelloWorld.vue';
import AboutView from "@/views/AboutView.vue";
import HeaderApp from "@/views/headerApp.vue";
import PicLink from "@/components/PicLink.vue";
import FooterApp from "@/views/FooterApp.vue";
import Category from "@/components/Category.vue";
import Products from "@/components/Products.vue";
import router from "@/router";

export default defineComponent({
  name: 'HomeView',
  methods:{
    checkLogin(){
      if(localStorage.getItem("token")==null){
        router.push("/login");
      }
    }
  },
  mounted() {
    // this.checkLogin();
  },
  components: {
    Products,
    Category,
    FooterApp,
    PicLink,
    HeaderApp,
    HelloWorld,
  },
});
</script>

<style scoped>
  .main{
    padding: 60px 0 60px;
    height: calc(100% +100px);
  }
</style>
